import { render, staticRenderFns } from "./Posts.vue?vue&type=template&id=64a5fe30&scoped=true&"
import script from "./Posts.vue?vue&type=script&lang=js&"
export * from "./Posts.vue?vue&type=script&lang=js&"
import style0 from "./Posts.vue?vue&type=style&index=0&id=64a5fe30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a5fe30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64a5fe30')) {
      api.createRecord('64a5fe30', component.options)
    } else {
      api.reload('64a5fe30', component.options)
    }
    module.hot.accept("./Posts.vue?vue&type=template&id=64a5fe30&scoped=true&", function () {
      api.rerender('64a5fe30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Support/TicketSingle/Posts.vue"
export default component.exports